// @format

export function initCommentSidebar() {
  var params = new URLSearchParams(window.location.search);
  loadIfAutoQueryCommentsPresent()
  if (params.get('comment_sidebar_user_company_id')) {
    loadCommentSidebar(
      params.get('comment_sidebar_user_company_id'),
      params.get('comment_sidebar_bot_id'),
      params.get('comment_sidebar_auto_query_id'),
    );
  }
  // Namespaced + re-bound each init so turbo re-renders don't stack duplicate handlers.
  const close = () => $('.comment-sidebar').remove();
  $(document).off('click.commentSidebar keydown.commentSidebar');
  $(document).on('click.commentSidebar', '.open-comment-sidebar', e => {
    e.preventDefault();
    let t = $(e.currentTarget);
    loadCommentSidebar(t.data('user-company-id'), t.data('bot-id'), t.data('auto-query-id'));
  });
  // Close on the X button or a click on the backdrop (both carry data-close-comment-sidebar).
  $(document).on('click.commentSidebar', '.close-comment-sidebar, [data-close-comment-sidebar]', e => {
    e.preventDefault();
    close();
  });
  $(document).on('keydown.commentSidebar', e => {
    if (e.key === 'Escape') close();
  });
  // Filter the activity list by commentable type (All / Company / Campaign / Targeting).
  $(document).on('click.commentSidebar', '[data-comment-filter]', e => {
    const btn = $(e.currentTarget);
    const filter = String(btn.data('comment-filter'));
    const drawer = btn.closest('.comment-sidebar');
    drawer.find('[data-comment-filter]').removeClass('active');
    btn.addClass('active');
    drawer.find('.comment-card').each((_i, el) => {
      const card = $(el);
      card.toggle(filter === 'all' || String(card.data('comment-type')) === filter);
    });
    const visible = drawer.find('.comment-card:visible').length;
    drawer.find('.cmt-count').text(`${visible} ${visible === 1 ? 'item' : 'items'}`);
  });
}

function loadIfAutoQueryCommentsPresent(){
  let t = $('.open-comment-sidebar')
  if (window.location.href.indexOf("auto_queries") > -1 && t && t.hasClass('auto-query-comments')){
    loadCommentSidebar(t.data('user-company-id'), t.data('bot-id'), t.data('auto-query-id'));
  }
}

function loadCommentSidebar(userCompanyId: string, botId: string, autoQueryId: string) {
  if (history.pushState) {
    var params = new URLSearchParams(window.location.search);
    params.set('comment_sidebar_user_company_id', userCompanyId);
    params.set('comment_sidebar_bot_id', botId);
    params.set('comment_sidebar_auto_query_id', autoQueryId);
    var newUrl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname +
      '?' +
      params.toString();
    window.history.replaceState({path: newUrl}, '', newUrl);
  }
  $.ajax({
    url:
      '/comments/sidebar?user_company_id=' + userCompanyId + '&bot_id=' + botId + '&auto_query_id=' + autoQueryId,
    success: function(jqXHR) {
      $('.comment-sidebar').remove();
      $('body').prepend(jqXHR);
    },
  });
}
